export default function getScrollableParent(node: Nullable<Element>): Element | null {
  const body = document.body;
  // The walk relies on `parentElement` and `offsetHeight`, both of which are HTMLElement-only.
  let current = node as Nullable<HTMLElement>;

  while (current) {
    if (_hasScroll(current)) {
      return current === body || current.contains(body) ? mainScrollingElement() : current;
    }

    if (!current.parentElement) {
      return null;
    }
    current = current.parentElement;
  }

  return null;
}

export function mainScrollingElement(): Element {
  return document.scrollingElement || document.documentElement;
}

function _hasScroll(el: HTMLElement): boolean {
  return el.scrollHeight > (el.clientHeight || el.offsetHeight) + 2;
}
